import { Stack, useMediaQuery, useTheme } from '@mui/material'
import { styled } from '@mui/system'

export const StyledFilterMenu = styled(Stack)(({ theme }) => ({
  width: '100%',
  minWidth: '200px',
  height: '100%',
  backgroundColor: 'background.main',
  borderRadius: '8px',
  border: '1px solid',
  borderColor: theme.palette.background.elevation7,
  padding: useMediaQuery(useTheme().breakpoints.down('sm')) ? theme.spacing(2) : theme.spacing(3),
  paddingLeft: 0,
  marginBottom: theme.spacing(1.5),
  maxHeight: '605px',
  gap: theme.spacing(3),
  zIndex: 30,
  overflow: 'auto',
}))
